import { createMicroConversionTrackingUtils } from "..";
import { useEffect } from "react";
import useLocaleContext from "hooks/useLocaleContext";
import useProfiler from "hooks/useProfiler";

const utils = createMicroConversionTrackingUtils({
  name: "flights_web_merge_filters_and_sort_mdot",
  stages: {
    allSr: 1,
    english: 2,
    nonEnglish: 3,
    direct: 4,
    meta: 5,
    us: 6,
    nonUs: 7
  },
  defaultStage: 1,
  mainStage: 1,
  goals: {
    sortTabClick: 1,
    filterTabClick: 2,
    sortAndFilterTabClick: 3
  }
});

const useTrackStages = () => {
  const { stages } = utils;
  const { locale } = useLocaleContext();
  const isEnglish = locale?.code.toLowerCase().startsWith("en-");
  const { isMeta, isAmerican } = useProfiler();

  useEffect(() => {
    stages.allSr();
    isEnglish ? stages.english() : stages.nonEnglish();
    isMeta() ? stages.meta() : stages.direct();
    isAmerican() ? stages.us() : stages.nonUs();
  }, [isAmerican, isEnglish, isMeta, stages]);
};

export default { ...utils, useTrackStages };
